export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 获取支付配置
     * @description
     */
    PAY_SET_ALL: function PAY_SET_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/mollie-set/index/',
        method: 'post',
        data: query
      });
    },

    /**
     * @description 获取支付配置
     * @description
     */
    PAY_SET_DETAIL: function PAY_SET_DETAIL(quer) {
      return request({
        url: '/api/mollie-set/detail/',
        method: 'post',
        data: {
          id: quer
        }
      });
    },

    /**
     * @description 创建支付配置
     * @description
     */
    PAY_SET_CREATE: function PAY_SET_CREATE(data) {
      return request({
        url: '/api/mollie-set/create/',
        method: 'POST',
        data: data
      });
    },

    /**
     * @description 编辑
     * @description
     */
    ROLEPAY_SET_UPDATE: function ROLEPAY_SET_UPDATE(data) {
      return request({
        url: '/api/mollie-set/update/',
        method: 'post',
        data: data
      });
    },

    /**
     * @description 删除
     * @description
     */
    ROLEPAY_SET_DELETE: function ROLEPAY_SET_DELETE(id) {
      return request({
        url: '/api/mollie-set/delete/',
        method: 'post',
        data: {
          id: id
        }
      });
    }
  };
});